import * as Yup from 'yup';

export const identityValidationSchema = Yup.object().shape({
  bvn: Yup.string()
    .required('BVN is required')
    .matches(/^[0-9]+$/, 'BVN must contain only numbers')
    .length(11, 'BVN must be exactly 11 digits')
    .test('is-valid-bvn', 'Please enter a valid BVN', (value) => {
      if (!value) return false;
      return !/^0{11}$/.test(value) && !/^(\d)\1{10}$/.test(value);
    }),

  nin: Yup.string()
    .required('NIN is required')
    .matches(/^[0-9]+$/, 'NIN must contain only numbers')
    .length(11, 'NIN must be exactly 11 digits')
    .test('is-valid-nin', 'Please enter a valid NIN', (value) => {
      if (!value) return false;
      return !/^0{11}$/.test(value) && !/^(\d)\1{10}$/.test(value);
    }),

  internationalPassport: Yup.mixed()
    .required('International Passport is required')
    .test('fileSize', 'File size must be less than 20MB', (value) => {
      if (!value) return false;
      if (value instanceof File) {
        return value.size <= 20 * 1024 * 1024;
      }
      return true;
    })
    .test(
      'fileType',
      'Only PDF, PNG, JPG, JPEG, or BMP files are allowed',
      (value) => {
        if (!value) return false;
        if (value instanceof File) {
          const allowedTypes = [
            'application/pdf',
            'image/png',
            'image/jpg',
            'image/jpeg',
            'image/bmp',
          ];
          return allowedTypes.includes(value.type);
        }
        return true;
      }
    ),
  paybackPeriod: Yup.string().required('Repayment date is required'),
  termsAndCondition: Yup.boolean().oneOf(
    [true],
    'You must accept the terms and conditions'
  ),
});
